import React, { useEffect, useState } from "react";
import { upload_file_to_s3 } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import FileUploadComponent from "../../Components/customComponents/customUpload";
import Select from "../../Components/customComponents/customSelect";
import {
  usaEmployeeSlice,
  MULTI_DOC_FIELDS,
} from "../../store/reducers/usaEmployeeSlice";

const UsaDocuments = ({ onchange, isfilled }) => {
  const documents = useSelector(
    (state) => state?.usaEmployee?.intialUsEmployee?.documents || {}
  );
  const immigrationDocumentsList = useSelector(
    (state) =>
  state?.usaEmployee?.intialUsEmployee?.immigrationDocumentsList || ""
  );
  const feildDisabled = useSelector(
    (state) => state?.usaEmployee?.feildsDisabled
  );
  const Originaldocuments = useSelector(
    (state) => state?.usaEmployee?.intialUsEmployee?.documents || {}
  );
  const [documentType, setDocumentype] = useState(immigrationDocumentsList || "");
  const dispatch = useDispatch();
  const handleUpload = async (new_file, label) => {
    const filename = new_file?.target?.name || "";
    const files = Array.from(new_file?.target?.files || []);
    try {
      const uploadedFiles = [];

      for (const file of files) {
        const maxSizeInBytes = 10 * 1024 * 1024;

        if (file?.size > maxSizeInBytes) {
          alert(`${file.name} exceeds 10MB`);
          continue;
        }

        const s3path = await upload_file_to_s3(file);
        const documentValue = {
          fileName: filename,
          name: file.name,
          resourceName: label,
          uploadDate: new Date().toISOString(),
          comment: "",
          extension: file.name.split(".").pop(),

          s3Document: {
            ...(s3path?.data?.data || {}),
            originalFileName: file.name,
          },
        };

        uploadedFiles.push(documentValue);
      }

      const existingFiles = Array.isArray(documents?.[filename])
        ? documents?.[filename].flat()
        : [];

      const finalValue = MULTI_DOC_FIELDS.includes(filename)
        ? [...existingFiles, ...uploadedFiles].flat()
        : uploadedFiles[0];

      onchange(
        {
          target: {
            name: filename,
            value: finalValue,
          },
        },
        "documents",
      );
    } catch (e) {
      console.error(e, "upload error");
    }
  };
  const handleRemove = (filename, index) => {
    const existing = Array.isArray(documents?.[filename])
      ? documents[filename]
      : [];
    const updated = existing.filter((_, i) => i !== index);
    onchange(
      {
        target: {
          name: filename,
          value: updated,
        },
      },
      "documents",
    );
  };
  const decideDocuments = (e) => {
    const { value, name } = e.target;
    dispatch(usaEmployeeSlice.actions.setImmigrationDocumentsList(value));
    setDocumentype(value);
  };

  useEffect(() => {
    if (immigrationDocumentsList?.trim?.() !== "") {
      setDocumentype(immigrationDocumentsList);
    }
  }, []);
  return (
    <div>
      <div className="flex items-center gap-3 mb-3">
        <p className="font-medium">OTHER DOCUMENTS:</p>
        <Select
          name={"immigrationDocumentsList"}
          onChange={(e) => decideDocuments(e)}
          value={documentType}
          disabled={feildDisabled}
          options={[
            { value: "f1Student", label: "F1-Student" },
            { value: "optcpt", label: "OPT/CPT" },
            { value: "h1b", label: "H1B" },
            { value: "other", label: "other" },
          ]}
        />
        {documentType === "" && (
          <p className="text-red-600 mx-3">Please Select an option</p>
        )}
      </div>
      <div className="flex flex-col p-6 w-[60%] gap-3">
        {(documentType === "f1Student" || documentType === "other") && (
          <FileUploadComponent
            name="offerLetterV1"
            label="Offer Letter"
            files={
              Array.isArray(documents?.offerLetterV1)
                ? documents.offerLetterV1.filter((f) => f?.name)
                : []
            }
            onRemove={(i) => handleRemove("offerLetterV1", i)}
            handleUploade={(e) => handleUpload(e, "Offer Letter")}
            isMandatory={true}
            isMultiple={true}
            showAddButton={true}
            isDisabled={feildDisabled}
            Originaldocuments={
              Array.isArray(Originaldocuments?.offerLetterV1)
                ? Originaldocuments.offerLetterV1
                    .map((file) => file?.name)
                    .join(", ")
                : ""
            }
            className={`${
              !documents?.offerLetterV1?.length &&
              isfilled &&
              immigrationDocumentsList !== "other" &&
              "true"
            }`}
          />
        )}
        {(documentType === "h1b" || documentType === "other") && (
          <FileUploadComponent
            name="agreementLetterV1"
            label="Agreement Letter"
            files={
              Array.isArray(documents?.agreementLetterV1)
                ? documents.agreementLetterV1.filter((f) => f?.name)
                : []
            }
            onRemove={(i) => handleRemove("agreementLetterV1", i)}
            handleUploade={(e) => handleUpload(e, "Agreement Letter")}
            isMandatory={false}
            isMultiple={true}
            showAddButton={true}
            isDisabled={feildDisabled}
            Originaldocuments={
              Array.isArray(Originaldocuments.agreementLetterV1)
                ? Originaldocuments.agreementLetterV1
                    .map((file) => file?.name)
                    .join(", ")
                : ""
            }
          />
        )}
        {(documentType === "h1b" || documentType === "other") && (
          <FileUploadComponent
            name="employmentDocument"
            label="Employment Document"
            files={
              Array.isArray(documents?.employmentDocument)
                ? documents.employmentDocument.filter((f) => f?.name)
                : []
            }
            onRemove={(i) => handleRemove("employmentDocument", i)}
            handleUploade={(e) => handleUpload(e, "Employment Document")}
            isMandatory={true}
            isMultiple={true}
            showAddButton={true}
            isDisabled={feildDisabled}
            Originaldocuments={
              Array.isArray(Originaldocuments.employmentDocument)
                ? Originaldocuments.employmentDocument
                    .map((file) => file?.name)
                    .join(", ")
                : ""
            }
            className={`${
              !documents.employmentDocument?.filter((f) => f?.name)?.length &&
              isfilled &&
              immigrationDocumentsList !== "other" &&
              "true"
            }`}
          />
        )}
        {(documentType === "h1b" || documentType === "other") && (
          <FileUploadComponent
            name="h1BDocuments"
            files={
              Array.isArray(documents?.h1BDocuments)
                ? documents.h1BDocuments.filter((f) => f?.name)
                : []
            }
            onRemove={(i) => handleRemove("h1BDocuments", i)}
            isMultiple={true}
            showAddButton={true}
            label="H-1B Document"
            handleUploade={(e) => handleUpload(e, "H-1B Document")}
            isDisabled={feildDisabled}
            Originaldocuments={
              Array.isArray(Originaldocuments.h1BDocuments)
                ? Originaldocuments.h1BDocuments
                    .map((file) => file.name)
                    .join(", ")
                : ""
            }
            className={`${
              !documents.h1BDocuments?.length &&
              isfilled &&
              immigrationDocumentsList !== "other" &&
              "true"
            }`}
          />
        )}
        {(documentType === "h1b" || documentType === "other") && (
          <FileUploadComponent
            name="f1VisaDocumentsV1"
            label="F1 VISA Document"
            files={
              Array.isArray(documents?.f1VisaDocumentsV1)
                ? documents.f1VisaDocumentsV1.filter((f) => f?.name)
                : []
            }
            onRemove={(i) => handleRemove("f1VisaDocumentsV1", i)}
            handleUploade={(e) => handleUpload(e, "F1 VISA Document")}
            isMandatory={false}
            isMultiple={true}
            showAddButton={true}
            isDisabled={feildDisabled}
            Originaldocuments={
              Array.isArray(Originaldocuments.f1VisaDocumentsV1)
                ? Originaldocuments.f1VisaDocumentsV1
                    .map((file) => file?.name)
                    .join(", ")
                : ""
            }
          />
        )}
        {(documentType === "optcpt" || documentType === "other") && (
          <FileUploadComponent
            name="opt"
            files={
              Array.isArray(documents?.opt)
                ? documents.opt.filter((f) => f?.name)
                : []
            }
            onRemove={(i) => handleRemove("opt", i)}
            isMultiple={true}
            showAddButton={true}
            label="OPT Document"
            handleUploade={(e) => handleUpload(e, "OPT Document")}
            isMandatory={true}
            isDisabled={feildDisabled}
            Originaldocuments={
              Array.isArray(Originaldocuments.opt)
                ? Originaldocuments.opt.map((file) => file.name).join(", ")
                : ""
            }
            className={`${
              !(documents?.opt?.filter((f) => f?.name)?.length > 0) &&
              isfilled &&
              immigrationDocumentsList !== "other" &&
              "true"
            }`}
          />
        )}
        {(documentType === "h1b" || documentType === "other") && (
          <FileUploadComponent
            name="ead"
            label="EAD Document"
            files={
              Array.isArray(documents?.ead)
                ? documents.ead.filter((f) => f?.name)
                : []
            }
            onRemove={(i) => handleRemove("ead", i)}
            handleUploade={(e) => handleUpload(e, "EAD Document")}
            isMandatory={false}
            isMultiple={true}
            showAddButton={true}
            isDisabled={feildDisabled}
          />
        )}
        {documentType !== "h1b" &&
          documentType?.trim?.() !== "" && (
            <FileUploadComponent
              name="i20Form"
              files={
                Array.isArray(documents?.i20Form)
                  ? documents.i20Form.filter((f) => f?.name)
                  : []
              }
              onRemove={(i) => handleRemove("i20Form", i)}
              isMultiple={true}
              showAddButton={true}
              label="I-20"
              handleUploade={(e) => handleUpload(e, "I-20")}
              isMandatory={true}
              isDisabled={feildDisabled}
              Originaldocuments={
                Array.isArray(Originaldocuments.i20Form)
                  ? Originaldocuments.i20Form
                      .map((file) => file.name)
                      .join(", ")
                  : ""
              }
              className={`${
                !documents.i20Form?.filter((f) => f?.name)?.length &&
                isfilled &&
                immigrationDocumentsList !== "other" &&
                "true"
              }`}
            />
          )}
        {documentType !== "" && documentType !== undefined && (
          <FileUploadComponent
            name="educationalDocuments"
            files={
              Array.isArray(documents?.educationalDocuments)
                ? documents.educationalDocuments.filter((f) => f?.name)
                : []
            }
            onRemove={(i) => handleRemove("educationalDocuments", i)}
            isMultiple={true}
            showAddButton={true}
            label="Educational Documents"
            handleUploade={(e) => handleUpload(e, "Educational Documents")}
            isDisabled={feildDisabled}
            Originaldocuments={
              Array.isArray(Originaldocuments.educationalDocuments)
                ? Originaldocuments.educationalDocuments
                    .map((file) => file.name)
                    .join(", ")
                : ""
            }
            className={`${
              !documents.educationalDocuments?.length &&
              isfilled &&
              immigrationDocumentsList !== "other" &&
              "true"
            }`}
          />
        )}
      </div>
    </div>
  );
};

export default UsaDocuments;
